import React from 'react';

/**
 * EazySparkIcon — Custom Eazy Tab Icon (Magnifier + Orange 4-Point AI Spark)
 *
 * Based on DEV_HANDOVER_EazyCourseEngine_UI.md Section 6.
 *
 * This is a custom icon for the "Eazy" tab in bottom navigation.
 * DO NOT use a standard icon library search icon — this must be the custom design.
 *
 * Key design:
 * - Magnifying glass: inherits currentColor (blue when active, grey when inactive)
 * - AI Spark: ALWAYS orange var(--brand-secondary) — the signature EazyCourseEngine accent
 *
 * @param {Object} props
 * @param {number} props.size - Size in pixels (default: 20)
 * @param {string} props.className - Additional CSS classes
 */
const EazySparkIcon = ({ size = 20, className = '' }) => {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      className={className}
      aria-label="Eazy Search"
    >
      {/* Magnifying glass circle */}
      <circle cx="10" cy="10" r="7" stroke="currentColor" strokeWidth="1.8" />
      {/* Magnifying glass handle */}
      <line
        x1="15.5"
        y1="15.5"
        x2="21"
        y2="21"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
      />
      {/* 4-point AI spark — ALWAYS orange var(--brand-secondary) */}
      {/* Top blade */}
      <path
        d="M10 5.5 L10.6 9 L10 10 L9.4 9 Z"
        fill="var(--brand-secondary)"
      />
      {/* Right blade */}
      <path
        d="M14.5 10 L11 10.6 L10 10 L11 9.4 Z"
        fill="var(--brand-secondary)"
      />
      {/* Bottom blade */}
      <path
        d="M10 14.5 L9.4 11 L10 10 L10.6 11 Z"
        fill="var(--brand-secondary)"
      />
      {/* Left blade */}
      <path
        d="M5.5 10 L9 9.4 L10 10 L9 10.6 Z"
        fill="var(--brand-secondary)"
      />
      {/* Center dot */}
      <circle cx="10" cy="10" r="1.2" fill="var(--brand-secondary)" />
    </svg>
  );
};

export default EazySparkIcon;
